'use strict';
var CartWidget, LanguageSelector, SignInFlyout, User, addMQListener, addReferrer, appendLanguageMenu, fetchUser, matchMQ, myPlacesWidget, my_stuff_layout_template, my_stuff_menu_template, ref, removeCachedUserData, setCartWidget, toggleUserMenuPlacement, updateSigninFlyoutPlacement, user_nav_template;

my_stuff_menu_template = require('../my_stuff_menu.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

user_nav_template = require('../vVERSION.html.mustache');

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../src/frontend/helper/general/m_userSessionAddReferrer').addReferrer;

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;

CartWidget = require('../../../../cart_widget/frontend/cart_widget');

SignInFlyout = require('../../signin_flyout/frontend/signin_flyout');

LanguageSelector = require('../../language_menu/frontend/language_selector');

ref = require('../../../../../src/frontend/helper/mediaQueries/mediaQueries'), matchMQ = ref.matchMQ, addMQListener = ref.addMQListener;

myPlacesWidget = require('../../../../my_places/frontend/myplaces_widget');


/**
 * @public
 */

removeCachedUserData = function() {
  return fetchUser.removeUserData();
};

setCartWidget = function() {
  if ($('#ls-user-nav .cart-widget').length) {
    return new CartWidget('.cart-widget');
  }
};

appendLanguageMenu = function(hasUser) {
  var $container, $langMenu;
  $langMenu = $('#ls-lang-menu').removeClass('ls-hide');
  if (!$langMenu.length) {
    return;
  }
  new LanguageSelector();
  if (!$('.big-searchbar').length) {
    return;
  }
  $container = $('#ls-user-nav .user-menu');
  if (hasUser) {
    return $langMenu.insertAfter('#user-help');
  } else {
    return $container.append($langMenu);
  }
};

updateSigninFlyoutPlacement = function() {
  var matches;
  $('#ls-user-signin-with-flyout').removeClass('ls-hide-visibility');
  $('#ls-user-signup').removeClass('ls-hide');
  matches = matchMQ("(max-width: 960px)");
  return toggleUserMenuPlacement(matches);
};

toggleUserMenuPlacement = function(moveFlyoutsToUpperContainer) {
  var selector;
  selector = moveFlyoutsToUpperContainer ? '#ls-header-upper-signin-container' : '#ls-header-lower-signin-container';
  return $(selector).append($('#user-name, #ls-my-stuff, #ls-header-signin-flyout-container'));
};

User = {
  init: function() {
    var ref1, ref2;
    if (!$('#ls-user-nav').length) {
      return;
    }
    this.showSigninFlyout = (ref1 = Groupon.LS.experiments) != null ? ref1.showSigninFlyout : void 0;
    this.translations = (ref2 = Groupon.LS.translations) != null ? ref2.userNav : void 0;
    this.country_US = document.head.getAttribute('data-country') === 'US';
    this.isLivingSocial = document.head.getAttribute('data-brand') === 'livingsocial';
    return this.fetchWithTokenExchange();
  },
  initFlyout: function(user) {
    if (this.showSigninFlyout) {
      SignInFlyout.init();
      this.renderMyStuffMenu(user, 'ls-signin-flyout-mystuff-pane');
      SignInFlyout.bind();
      return addMQListener("(max-width: 960px)", function(mq) {
        return toggleUserMenuPlacement(mq.matches);
      });
    }
  },
  fetchWithTokenExchange: function() {
    return fetchUser.exchangeTokenIfNeed(((function(_this) {
      return function() {
        return _this.fetch();
      };
    })(this)));
  },
  fetch: function() {
    var error, hasUserData, hasUser_cb, noUser_cb, ref1, success, userId;
    noUser_cb = (function(_this) {
      return function() {
        addReferrer();
        if (_this.showSigninFlyout) {
          updateSigninFlyoutPlacement();
          _this.initFlyout();
        }
        setCartWidget();
        appendLanguageMenu(false);
        myPlacesWidget.fetchMyPlaces(false);
      };
    })(this);
    hasUser_cb = (function(_this) {
      return function(res) {
        _this.renderUserNav(res);
        if (_this.showSigninFlyout) {
          updateSigninFlyoutPlacement();
          _this.initFlyout(res);
        }
        _this.renderMyStuffLayout(res);
        Groupon.Modules.Header.bind();
        delete Groupon.Modules.Header;
        setCartWidget();
        appendLanguageMenu(true);
        myPlacesWidget.fetchMyPlaces(true);
      };
    })(this);
    success = hasUser_cb;
    ref1 = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref1.userId, hasUserData = ref1.hasUserData;
    if (hasUserData || !userId) {
      return;
    }
    error = function(err) {
      noUser_cb();
      Groupon.Utils.trackEvent('user-call-failed', err);
    };
    return fetchUser.fetch(userId, success, error);
  },
  loadViewData: function() {
    var flagData, ref1, ref2;
    flagData = Groupon.LS.flags || {};
    return Object.assign(flagData, {
      showWishlist: ((ref1 = Groupon.LS.flags) != null ? ref1.showWishlist : void 0) && ($('#ls-lite-header').length != null),
      t: this.translations,
      country_US: this.country_US,
      showSigninFlyout: this.showSigninFlyout,
      showLiteHeader: $('#ls-lite-header').length != null,
      enableBigSearch: $('.big-searchbar').length != null,
      showCart: (ref2 = Groupon.Cart) != null ? ref2.showCart : void 0
    });
  },
  renderMyStuffMenu: function(user, containerId) {
    var data, linksToUpdate, ref1;
    data = Object.assign({}, this.loadViewData(), {
      user: user
    });
    if ((ref1 = data.t) != null) {
      if (ref1.myProfileLink == null) {
        ref1.myProfileLink = '/myprofile';
      }
    }
    if (!user) {
      linksToUpdate = ['myGrouponsLink', 'myCardLinkedDealsLink', 'myWishlistLink', 'myAccountLink', 'myProfileLink'];
      Object.keys(data.t).filter(function(i) {
        return linksToUpdate.indexOf(i) > -1;
      }).forEach(function(key) {
        var link;
        link = data.t[key];
        data.t[key] = "/login?metric=layout_login&ref=" + (encodeURIComponent(link));
      });
      data.t['signUpLink'] = data.t['signUpLink'] + "?metric=layout_login";
    }
    return $('#' + containerId).html(my_stuff_menu_template.render(data));
  },
  renderUserNav: function(user) {
    var data, ref1, ref2;
    data = Object.assign({}, this.loadViewData(), {
      user: user
    });
    $('#ls-user-nav').html(user_nav_template.render(data));
    if (this.showSigninFlyout) {
      $('#ls-header-signin-flyout-container').remove();
    }
    this.renderMyStuffMenu(user, 'ls-my-stuff');
    addReferrer('#ls-user-nav');
    if ((ref1 = Cookie.get('has_cpp')) === '1' || ref1 === 'true') {
      $('#user-my-page').removeClass('hidden');
    }
    if ((ref2 = Groupon.PageFlags) != null ? ref2.isLegacyResponsive : void 0) {
      new Groupon.LS.Header.PNResponsiveMenu;
    }
    $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
  },
  renderMyStuffLayout: function(user) {
    var $myStuffSelector, current, data, ref1, ref2, ref3, ref4;
    if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
      return;
    }
    current = Groupon.LS.CurrentMyStuffApp;
    data = {
      current: current,
      user: user,
      t: this.translations,
      country_US: this.country_US,
      isLivingSocial: this.isLivingSocial,
      showMyFoodTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyFoodTab : void 0,
      showMyLinkedDealsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyLinkedDealsTab : void 0,
      showMyReservationsTab: (ref3 = Groupon.LS.flags) != null ? ref3.showMyReservationsTab : void 0,
      showMyProfile: (ref4 = Groupon.LS.flags) != null ? ref4.showMyProfile : void 0
    };
    return $myStuffSelector.html(my_stuff_layout_template.render(data));
  }
};

Groupon.LS.User = {
  removeCachedUserData: removeCachedUserData
};

module.exports = {
  User: User
};

